import { useQueryClient } from "@tanstack/react-query";
import { useCallback } from "react";

export const VISITOR_SETTINGS_QUERY_KEY = "visitorSettings";

/**
 * Invalidates the organization-wide visitor management settings
 * (notification templates and excluded hosts). Use after saving them.
 */
export const useInvalidateVisitorSettings = () => {
  const queryClient = useQueryClient();

  return useCallback(async () => {
    await queryClient.invalidateQueries({
      queryKey: [VISITOR_SETTINGS_QUERY_KEY]
    });
  }, [queryClient]);
};
